<template>
  <div class="collectionRequest">
    <main class="list-table mt-5">
      <div class="row">
        <div class="col-md-12">
          <div class="form d-flex align-items-center">
            <p>{{ $t("lostItems.tabs.Collected.text") }}</p>
            <Json2Csv
              class="ml-auto"
              v-if="items.length > 0"
              :json-data="csvData"
              :csv-title="`Lost_Items_Collected`"
            >
              <button class="btn btn-download">
                {{ $t("lostItems.btnDownload") }}
              </button>
            </Json2Csv>
          </div>
        </div>
      </div>
      <v-client-table
        v-if="items"
        :columns="tableColumns.columns"
        :options="table_options.options"
        :data="items"
      >
        <!-- Actions -->

        <template v-slot:dateCollection="props"
          >{{ props.row.formatDate }}, {{ props.row.formatTime }}</template
        >
        <template v-slot:categoryAndStatus="props">
          <div class="folio">
            <select
              v-model="props.row.categoryId"
              @change="getCategorySelected($event, props.index)"
            >
              <option disabled value>Seleccione un elemento</option>
              <option
                v-for="(category, index) in categories"
                :value="category.id"
                :key="index"
                >{{ category.name }}</option
              >
            </select>
            <div class="checkbox">
              <!-- <input
                type="checkbox"
                id="c"
                :disabled="
                  !category.hasOwnProperty(props.index - 1) ||
                    category[props.index - 1] === '' ||
                    category[props.index - 1] === null
                "
                @click="openModal(props.row, del=false)"
              />
              <label for="c">
                {{
                $t("lostItems.tabs.Collected.table.checkbox")
                }}
              </label>-->
              <button
                class="btn btn-collected"
                :disabled="
                  !category.hasOwnProperty(props.index - 1) ||
                    category[props.index - 1] === '' ||
                    category[props.index - 1] === null
                "
                @click="openModal(props.row, (del = false))"
              >
                {{ $t("lostItems.tabs.Collected.table.checkbox") }}
              </button>
            </div>
          </div>
        </template>
        <template v-slot:actions="props">
          <div class="actions">
            <!-- Edit -->
            <router-link
              class="edit-btn"
              :to="{
                name: 'Lost Item Detail',
                params: {
                  id: props.row.id,
                  object: props.row
                }
              }"
            >
              <i class="far fa-edit"></i>
            </router-link>
            <!-- Delete -->
            <i
              class="far fa-trash-alt"
              @click="openModal(props.row, (del = true))"
            ></i>
            <!--Detalles
            <i class="fas fa-chevron-right"></i>-->
          </div>
        </template>
      </v-client-table>
    </main>
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title bolded">
          {{ $t("lostItems.tabs.collectionRequests.modal.attention") }}
        </h6>
      </template>
      <template>
        <div class="modal-body-text">
          <p v-if="!isToDelete">
            {{ $t("lostItems.tabs.Collected.modal.body-text") }}
          </p>
          <p v-if="isToDelete">
            {{ $t("lostItems.tabs.collectionRequests.modal.delete-text") }}
          </p>
          <p class="mt-1">
            {{ $t("lostItems.tabs.collectionRequests.modal.body-text2") }}
          </p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">{{
            $t("map.benefits.list.modal.cancel")
          }}</span>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="isToDelete"
            @click="deleteItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.collectionRequests.modal.continue") }}
          </button>
          <button
            type=" button"
            class="btn control solve-btn"
            v-if="!isToDelete"
            @click="updateItem(itemToDelete)"
          >
            {{ $t("lostItems.tabs.Collected.modal.markAsInventoried") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/lostItems.js";
const api = new API_SERVICE();
import Json2Csv from "vue-json-to-csv";

const Modal = () => import("@/components/Modal");
import moment from "moment";
export default {
  components: {
    Modal,
    Json2Csv
  },
  data() {
    return {
      items: null,
      folio: "",
      page: 0,
      selected: "",
      categories: [],
      modalActive: false,
      itemToDelete: null,
      isToDelete: false,
      category: {},
      csvData: null,
      dictionary: {
        folio: this.$t("lostItems.tabs.Collected.table.headings.folio"),
        itemInfo: this.$t("lostItems.tabs.Collected.table.headings.itemInfo"),
        timeCollection: this.$t(
          "lostItems.tabs.Collected.table.headings.timeCollection"
        ),
        dateCollection: this.$t(
          "lostItems.tabs.Collected.table.headings.dateCollection"
        ),
        placeCollection: this.$t(
          "lostItems.tabs.Collected.table.headings.placeCollection"
        ),
        userName: this.$t("lostItems.tabs.Collected.table.headings.userName"),
        collector: this.$t("lostItems.tabs.Collected.table.headings.collector")
      }
    };
  },
  async beforeMount() {
    await this.getCategory();
    await this.getItems();
  },
  methods: {
    getItems: async function() {
      this.$store.commit("global/SET_LOADING", true);
      let queries = {
        page: this.page,
        limit: 999999,
        published: true,
        status: "collected"
      };
      try {
        const resp = await api.getLostItemsByStatus(queries);
        
        this.items = resp.result.result
                    .map(i => ({
                      ...i,
                      category: (this.categories.find(c => c.id === i.categoryId) || {}).name || "",
                      formatDate: moment(i.inventoryDate).format('YYYY/MM/DD'),
                      formatTime: i.timeCollection,
                    }))
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        this.itemsToDownload();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getCategorySelected: function(value, index) {
      this.items[index - 1].categoryId = +value.target.value;
      let cat = this.lodash.cloneDeep(this.category);
      cat[index - 1] = +value.target.value;
      this.category = cat;
    },
    getCategory: async function() {
      let currentLanguage = localStorage.getItem("lang");

      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.getLostItemsCategorys(currentLanguage);
        this.categories = resp.categories;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    deleteItem: async function(item) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        item.published = false;
        item.status = "deleted";
        const response = await api.updateItem(item.id, item);
        await this.getItems();
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
        this.itemToDelete = null;
      }
    },
    openModal: async function(item, del) {
      this.modalActive = true;
      this.isToDelete = del;
      this.itemToDelete = item;
    },
    closeModal: function() {
      this.modalActive = false;
      this.isToDelete = false;
      this.itemToDelete = null;
    },
    updateItem: async function(item) {
      const autor = this.$store.getters["session/author"];
      let newDate = new Date();
      let parseDate = moment(newDate).format("YYYY-MM-DD");
      let parseTime = moment(newDate).format("HH:MM");
      let params = {
        status: "inventoried",
        inventoriedBy: autor,
        itemInfo: item.itemInfo,
        inventoryDate: newDate,
        categoryId: item.categoryId,
        dateCollection: item.dateCollection,
        timeCollection: item.timeCollection,
        placeCollection: item.placeCollection
      };
      const response = await api.updateItem(item.id, params);
      await this.getItems();
      this.closeModal();
    },
    itemsToDownload: function() {
      const itemsFields = [
        "folio",
        "itemInfo",
        "dateCollection",
        "timeCollection",
        "placeCollection",
        "userName",
        "collector"
      ];
      let downloadArray = this.items.map(item => {
        let obj = {};
        itemsFields.forEach(field => {
          obj[this._translateHeader(field)] = item[field];
        });
        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    }
  },
  computed: {
    userRole() {
      return this.$store.getters["session/role"];
    },
    tableColumns() {
      if (this.userRole === "Security") {
        return {
          columns: [
            "folio",
            "itemInfo",
            "userName",
            "category",
            "dateCollection",
            "placeCollection",
            "collector"
          ]
        };
      } else {
        return {
          columns: [
            "folio",
            "itemInfo",
            "userName",
            "category",
            "dateCollection",
            "placeCollection",
            "collector",
            "categoryAndStatus",
            "actions"
          ]
        };
      }
    },
    table_options: function() {
      return {
        options: {
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            folio: this.$t("lostItems.tabs.Collected.table.headings.folio"),
            itemInfo: this.$t(
              "lostItems.tabs.Collected.table.headings.itemInfo"
            ),
            userName: this.$t(
              "lostItems.tabs.Collected.table.headings.userName"
            ),
            category: this.$t(
              "lostItems.tabs.Collected.table.headings.category"
            ),
            dateCollection: this.$t(
              "lostItems.tabs.Collected.table.headings.dateCollection"
            ),
            placeCollection: this.$t(
              "lostItems.tabs.Collected.table.headings.placeCollection"
            ),
            collector: this.$t(
              "lostItems.tabs.Collected.table.headings.collector"
            ),
            categoryAndStatus: this.$t(
              "lostItems.tabs.Collected.table.headings.categoryAndStatus"
            ),
            actions: this.$t("lostItems.tabs.Collected.table.headings.actions")
          },
          sortable: [
            "folio",
            "itemInfo",
            "userName",
            "category",
            "dateCollection",
            "placeCollection",
            "collector"
          ],
          filterable: ["itemInfo"],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          perPage: 10,
          resizableColumns: false,
          columnsClasses: {
            folio: "folio-col",
            itemInfo: "itemInfo-col",
            userName: "userName-col",
            userName: "category-col",
            dateCollection: "dateCollection-col",
            placeCollection: "placeCollection-col",
            collector: "collector-col",
            categoryAndStatus: "categoryAndStatus-col",
            actions: "actions-col"
          }
        }
      };
    },
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
.actions {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.actions > * {
  cursor: pointer;
}
.actions > .edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: $black;
  }
}
.folio {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.folio select{
  margin-bottom: 20px !important;
}
.folio input {
  width: 50% !important;
}
.checkbox {
  display: flex;
  width: 350px;
  align-items: center;
}
.v-select {
  width: 100%;
}
.vs__dropdown-toggle {
  color: $bg_1;
  border: none;
  border-bottom: 1px solid $wg_1;
  border-radius: 0;
}
#select-search-input {
  width: 0%;
  border: none;
}
.vs__dropdown-option:hover {
  background-color: $wg_3;
  color: $black;
}
.vs__dropdown-option--selected {
  background-color: $b_2;
  color: $white;
}
.vs__dropdown-option--highlight {
  background-color: $wg_3;
  color: $black;
}
.vs__actions {
  cursor: pointer;
}

.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  padding: 0 2px;
  position: relative;
}
</style>
<style>
.form-inline label {
  display: initial;
}
.collectionRequest .modal-container {
  max-width: 20vw !important;
  max-height: 60vh !important;
}
.collectionRequest .modal-container .controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.bolded {
  font-weight: bold !important;
}
.controls span {
  cursor: pointer;
}
.controls span:hover {
  text-decoration: underline;
}
.btn-download {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
}
.btn-collected {
  background: #000 !important;
  color: #fff !important;
  border-radius: 0px !important;
  width: 100%;
  margin-left: 1rem !important;
}
td {
  text-align: left !important;
  vertical-align: middle !important;
}

#VueTables_th--folio,
#VueTables_th--itemInfo {
  width: 200px !important;
}
#VueTables_th--categoryAndStatus,
#VueTables_th--folioAndStatus {
  width: 400px !important;
}
#VueTables_th--actions,
#VueTables_th--placeCollection,
#VueTables_th--collector,
#VueTables_th--userName,
#VueTables_th--inventoryDate #VueTables_th--inventoriedBy,
#VueTables_th--resolutionAction,
#VueTables_th--category,
#VueTables_th--resolvedBy,
#VueTables_th--resolution {
  width: 210px !important;
}
#VueTables_th--dateCollection {
  width: 300px !important;
}
</style>
<style>
@media (min-width: 768px) and (max-width: 1440px) {
  .collectionRequest .modal-container {
    max-width: 40vw !important;
    max-height: 60vh !important;
  }
}
</style>
